import { render, staticRenderFns } from "./budget-call.vue?vue&type=template&id=66fd49d8&"
import script from "./budget-call.vue?vue&type=script&lang=js&"
export * from "./budget-call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports